import { createApiSlice } from "@common";
import { CRUD_CHANNEL_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addChannelStatus",
    method: "post",
    url: CRUD_CHANNEL_STATUS,
    stateKey: "message",
  },
  {
    name: "getChannelStatus",
    method: "get",
    url: CRUD_CHANNEL_STATUS,
    stateKey: "data",
  },
  {
    name: "updateChannelStatus",
    method: "put",
    url: CRUD_CHANNEL_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteChannelStatus",
    method: "delete",
    url: CRUD_CHANNEL_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"channelStatus",
 apiConfig, 
 customReducers);
const channelStatusSlice = slice;

export default channelStatusSlice.reducer;

export const {
  addChannelStatus,
  getChannelStatus,
  updateChannelStatus,
  deleteChannelStatus,
} = thunks;

export const { rowSelect } = actions;
